module.exports = __webpack_public_path__ + "img/register-button.964604a7.png";